import React from "react";

import {
  ArrowLeft,
  Receipt,
  Landmark,
  Zap,
  Droplets,
  Wifi,
  GraduationCap,
  CreditCard,
  CheckCircle2,
  ShieldCheck,
} from "lucide-react";

import "../Styles/Bills.css";

import { useNavigate }
from "react-router-dom";

const billers = [

  {
    icon: Zap,
    name: "GPL",
    desc:
      "Guyana Power & Light bill payments.",
  },

  {
    icon: Droplets,
    name: "GWI",
    desc:
      "Guyana Water Incorporated services.",
  },

  {
    icon: Wifi,
    name: "E-NET",
    desc:
      "Internet and communication payments.",
  },

  {
    icon: Landmark,
    name: "IPED",
    desc:
      "Loans and financing payments.",
  },

  {
    icon: CreditCard,
    name: "Courts",
    desc:
      "Retail and installment bill payments.",
  },

  {
    icon: Receipt,
    name: "Wifi",
    desc:
      "Payment for Wakenaam's Major Wifi providers",
  },

  {
    icon: GraduationCap,
    name: "University Of Guyana",
    desc:
      "Tuition and fee payment support.",
  },

  {
    icon: Wifi,
    name: "GTT",
    desc:
      "Postpaid, landline and fibre services.",
  },

];

const Bills = () => {

  const navigate =
    useNavigate();

  return (

    <div className="modern-bills-page">

      {/* HERO */}
      <section className="modern-bills-hero">

        <div className="modern-bills-overlay" />

        <div className="modern-bills-content">

          <button
            className="modern-bills-back-btn"
            onClick={() =>
              navigate("/services")
            }
          >

            <ArrowLeft size={18} />
            Back To Services

          </button>

          <div className="modern-bills-badge">
            BILL PAYMENT SERVICES
          </div>

          <h1 className="modern-bills-heading">
            Pay All Your Bills
            <span> Under One Roof.</span>
          </h1>

          <p className="modern-bills-text">
            RCS delivers fast, reliable and
            hassle-free bill payment services
            with excellent response times and
            customer-focused support.
          </p>

        </div>

      </section>

      {/* FEATURES */}
      <section className="modern-bills-highlights">

        <div className="modern-bills-highlight-card">

          <div className="modern-bills-icon">
            <Receipt size={34} />
          </div>

          <h3>
            Fast Processing
          </h3>

          <p>
            Quick and efficient bill
            payment solutions.
          </p>

        </div>

        <div className="modern-bills-highlight-card">

          <div className="modern-bills-icon">
            <ShieldCheck size={34} />
          </div>

          <h3>
            Secure Transactions
          </h3>

          <p>
            Trusted and secure
            payment processing.
          </p>

        </div>

        <div className="modern-bills-highlight-card">

          <div className="modern-bills-icon">
            <Landmark size={34} />
          </div>

          <h3>
            Multiple Billers
          </h3>

          <p>
            Convenient access to
            many service providers.
          </p>

        </div>

      </section>

      {/* BILLERS */}
      <section className="modern-billers-section">

        <div className="modern-billers-header">

          <div className="modern-billers-badge">
            SUPPORTED BILLERS
          </div>

          <h2>
            Featured Billers
          </h2>

          <p>
            RCS provides payment
            solutions for a wide range
            of utility, educational and
            financial services.
          </p>

        </div>

        <div className="modern-billers-grid">

          {billers.map(
            (biller, index) => {

            const Icon =
              biller.icon;

            return (

              <div
                className="modern-biller-card"
                key={index}
              >

                <div className="modern-biller-icon">
                  <Icon size={30} />
                </div>

                <h3>
                  {biller.name}
                </h3>

                <p>
                  {biller.desc}
                </p>

                <div className="modern-biller-check">

                  <CheckCircle2
                    size={18}
                  />

                  Available At RCS

                </div>

              </div>
            );
          })}

        </div>

      </section>

      {/* FOOTER CTA */}
      <section className="modern-bills-cta">

        <div className="modern-bills-cta-card">

          <h2>
            Convenience You Can Trust
          </h2>

          <p>
         We also Support a wide range of other billers, Check us out today and enjoy hastle free services!
          </p>

        </div>

      </section>

    </div>
  );
};

export default Bills;